import {UsersTableActions} from "../const/ActionsConst";
import * as actions from '../actions/index';
import * as UserDetailsActions from '../actions/UserDetailsActions';


import client from '@common/utils/rest.js'
import {SORT_DIRECTION} from "@common/constants";

export const loadUsers = (sort = 'username', dir = SORT_DIRECTION.asc) => (dispatch) => {
    client({
        path: `api/userMaintenance/users?sort=${sort}&dir=${dir}`,
        headers: {'Pragma': 'no-cache'}
    })
        .then(
            response => {
                dispatch(usersLoaded(response.entity))
            },
            error => {
                console.log('getTestResults: ', error)
            }
        );
};

export const loadUser = (userId) => (dispatch) => {
    client({
        path: 'api/userMaintenance/users/' + encodeURIComponent(userId),
        headers: {'Pragma': 'no-cache'}
    })
        .then(
            response => {
                dispatch(userLoaded(response.entity))
            },
            error => {
                console.log('getTestResults: ', error)
            }
        );
};

export const filterUsers = (params) => {
    return {
        params,
        type: UsersTableActions.FILTER_USERS,
    };
}

export const usersLoaded = (usersList) => ({
    type: UsersTableActions.USERS_LOADED,
    users: usersList
});

export const userLoaded = (user) => ({
    type: UsersTableActions.USER_LOADED,
    user: user
});

export const selectUser = (username) => ({
    type: UsersTableActions.USER_SELECTED,
    username,
});

export const selectUsers = (selectedUsers = []) => ({
    type: UsersTableActions.SELECT_MULTIPLE_USERS,
    selectedUsers,
});

export const setDefaultColumnsWidth = (width) => ({
    type: UsersTableActions.SET_DEFAULT_COLUMNS_WIDTH,
    width: width
});

export const loadColumnsWidth = () => dispatch => {
    client({
        path: 'api/userMaintenance/columns',
        headers: {'Pragma': 'no-cache'}
    })
        .then(
            response => {dispatch(setColumnsWidth(response.entity))},
            error => {console.log('loadColumnsWidth: ', error);}
        );
};

export const saveColumnWidth = (newResized) => (dispatch, getState) => {
    let columns = {...getState().usersTable.table.columns};
    for (let res of newResized) {
        columns[res.id] = res.value;
    }
    client({
        path: 'api/userMaintenance/columns',
        method: 'POST',
        entity: columns
    })
        .then(
            () => {},
            error => {console.log('saveColumnWidth: ', error);}
        );
};

export const setColumnsWidth = columnsWidth => ({
    type: UsersTableActions.SET_COLUMNS_WIDTH,
    columns: columnsWidth
});

export const columnResized = (id, width) => ({
    type: UsersTableActions.COLUMN_RESIZED,
    id: id,
    width: width
});

const deleteUserRequest = (username) => {
    return client({
        path: 'api/userMaintenance/users/' + username + '/delete',
        method: 'POST'
    });
};

export const deleteUser = ()  => (dispatch, getState) => {
    const { username } = getState().userDetails.user;

    deleteUserRequest(username).then(
        () => {
            dispatch(loadUsers());
            dispatch(UserDetailsActions.clearUserDetails());
            dispatch(actions.showMessageBox(false))
        },
        error => {console.log('deleteUser: ', error);}
    )
};

export const deleteUsers = () => (dispatch, getState) => {
    const { selectedUsers } = getState().usersTable;

    Promise.all(selectedUsers.map((username) => deleteUserRequest(username)))
        .then(() => {
            dispatch(loadUsers());
            dispatch(UserDetailsActions.clearUserDetails());
            dispatch(actions.showMessageBox(false))
        })
        .catch((err) => console.error('delete users: ', err));
};
